"use strict";

var _interopRequireDefault = require("/root/www/xmg-cms-fe/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.function.name");

var _cat_list = require("@/api/cat_list");

var _get_cat_by_id = require("@/api/get_cat_by_id");

var _get_cat_tags = require("@/api/get_cat_tags");

var _cat_record = require("@/api/cat_record");

var _file_upload = require("@/api/file_upload");

var _Upload = _interopRequireDefault(require("@/components/Upload"));

var _video = _interopRequireDefault(require("@/components/Upload/video"));

var _multiple = _interopRequireDefault(require("@/components/Upload/multiple"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    Upload: _Upload.default,
    UploadVideo: _video.default,
    UploadMultiple: _multiple.default
  },
  data: function data() {
    var _this2 = this;

    var validateRequire = function validateRequire(rule, value, callback) {
      if (!value) {
        _this2.$message({
          message: rule.name + '是指定的必填内容，填写后才能提交！',
          type: 'error'
        });

        callback(new Error(rule.name + '为必填项！'));
      } else {
        callback();
      }
    };

    var validateTags = function validateTags(rule, value, callback) {
      if (value && value.length == 0) {
        _this2.$message({
          message: rule.field + '是指定的必填内容，填写后才能提交！',
          type: 'error'
        });

        callback(new Error(rule.field + '为必填项！'));
      } else {
        callback();
      }
    }; // const validateOnlie = (rule, value, callback) => {
    //   if (!value && this.editCatForm.banner_img === '') {
    //     this.$message({
    //       message: '上线的产品必须有封面图！请选择上传封面图或者选择下架这只猫！',
    //       type: 'error'
    //     })
    //     // callback(new Error(rule.field + '为必传项'))
    //   } else {
    //     callback()
    //   }
    // }


    return {
      editCatForm: {
        id: '',
        name: '',
        sex: '',
        birthday: '',
        tags: [],
        intro: '',
        status: '',
        recommend: false,
        // online: false,
        father_id: '',
        mother_id: '',
        brother_id_list: '',
        banner_img: '',
        birth_img: '',
        family_img: '',
        face_img: '',
        img_list: '',
        video_list: '',
        record_list: [{}],
        price: '',
        downpayment: '',
        discount: '',
        a: [{
          url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
        }, {
          url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
        }]
      },
      imageUrl: '',
      activeName: 'first',
      catList: null,
      tags: [],
      commonRecordList: null,
      state1: null,
      editCatFormRules: {
        name: [{
          required: true,
          name: '“名字” ',
          trigger: 'blur',
          validator: validateRequire
        }],
        sex: [{
          required: true,
          name: '“性别” ',
          trigger: 'blur',
          validator: validateRequire
        }],
        intro: [{
          required: true,
          name: '“简介” ',
          trigger: 'blur',
          validator: validateRequire
        }],
        tags: [{
          required: true,
          name: '“标签” ',
          trigger: 'blur',
          validator: validateTags
        }],
        status: [{
          required: true,
          name: '“上架状态” ',
          trigger: 'blur',
          validator: validateRequire
        }],
        // online: [{ required: true, trigger: 'blur' , validator: validateOnlie }],
        birthday: [{
          required: true,
          name: '“生日” ',
          trigger: 'blur',
          validator: validateRequire
        }],
        banner_img: [{
          required: true,
          name: '“封面图” ',
          trigger: 'blur',
          validator: validateRequire
        }],
        price: [{
          required: true,
          name: '“售价” ',
          trigger: 'blur',
          validator: validateRequire
        }],
        downpayment: [{
          required: true,
          name: '“定金” ',
          trigger: 'blur',
          validator: validateRequire
        }]
      }
    };
  },
  created: function created() {
    this.listLoading = true;
    this.editCatForm.id = this.$route.params.id;
    this.fetchData();
  },
  methods: {
    querySearch: function querySearch(queryString, cb) {
      var commonRecordList = this.commonRecordList;
      var results = queryString ? commonRecordList.filter(this.createFilter(queryString)) : commonRecordList; // 调用 callback 返回建议列表的数据

      cb(results);
    },
    createFilter: function createFilter(queryString) {
      return function (commonRecord) {
        return commonRecord.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1;
      };
    },
    fetchData: function fetchData() {
      var _this3 = this;

      // 获取猫列表数据
      // this.tags = getCatTagsList().catTagsList;
      (0, _get_cat_tags.getCatTags)().then(function (response) {
        var catTagsList = response.data;
        _this3.tags = catTagsList;
      });
      this.commonRecordList = (0, _cat_record.getCommonRecord)();
      (0, _cat_list.getList)().then(function (res_list) {
        var _this = _this3;
        var catList = res_list.data;
        catList.unshift({
          id: 0,
          name: '无'
        });
        _this3.catList = catList;

        if (_this3.editCatForm.id % 1 === 0) {
          // 如果id为数字尝试查找已存在的猫
          (0, _get_cat_by_id.getCat)(_this3.editCatForm.id).then(function (res_cat) {
            var cat = res_cat.cat;
            _this3.editCatForm.name = cat.name;
            _this3.editCatForm.sex = cat.sex;
            _this3.editCatForm.birthday = cat.birthday;
            _this3.editCatForm.tags = cat.tags.split(',').map(Number);
            _this3.editCatForm.intro = cat.intro;
            _this3.editCatForm.status = cat.status; // this.editCatForm.online = cat.online

            _this3.editCatForm.recommend = cat.recommend;
            _this3.editCatForm.video_list = cat.video_list;
            _this3.editCatForm.record_list = cat.record_list;
            _this3.editCatForm.price = cat.price;
            _this3.editCatForm.downpayment = cat.downpayment;
            _this3.editCatForm.discount = cat.discount;
            _this3.editCatForm.banner_img = cat.cat_img.banner_img;
            _this3.editCatForm.birth_img = cat.cat_img.birth_img;
            _this3.editCatForm.face_img = cat.cat_img.face_img;
            _this3.editCatForm.family_img = cat.cat_img.family_img;
            _this3.editCatForm.img_list = cat.cat_img.img_list;

            if (cat.family_relation) {
              _this3.editCatForm.father_id = cat.family_relation.father_id;
              _this3.editCatForm.mother_id = cat.family_relation.mother_id;
              _this3.editCatForm.brother_id_list = cat.family_relation.brother_id_list.split(',').map(Number);
            }

            if (_this.editCatForm.record_list) {
              var record_list = _this.editCatForm.record_list.split('$$$');

              record_list.map(function (item, index) {
                record_list[index] = JSON.parse(item);
              });
              _this3.editCatForm.record_list = record_list;
            } else {
              _this3.editCatForm.record_list = [{}];
            }

            _this3.listLoading = false;
          });
        } else {
          _this3.listLoading = false;
        } // JSON.parse(cat.record_list.split('$$$')[0]).date
        // console.log(this.editCatForm)
        // var record_list = this.editCatForm.record_list
        // record_list.map(function (item, index) {
        //   console.log('======')
        //   console.log(typeof(item))
        //   console.log(item)
        //   if(typeof(item) === 'string'){
        //     record_list[index] = JSON.parse(item)
        //   }
        // })
        // console.log(record_list[0].date)
        // console.log(this.editCatForm.record_list)
        // console.log(this.editCatForm.record_list)
        // console.log(this.editCatForm.record_list)

      });
    },
    addRecord: function addRecord() {
      this.editCatForm.record_list.push({});
    },
    onSubmit: function onSubmit() {
      var _this4 = this;

      this.$refs.editCatForm.validate(function (valid) {
        if (valid) {
          _this4.loading = true; // console.log(';;;;;;;;;;;;;;;')
          // console.log(this.editCatForm.discount)

          var cat = _this4.editCatForm;
          cat.record_list.map(function (item, index) {
            cat.record_list[index] = JSON.stringify(item);
          });
          cat.record_list = cat.record_list.join("$$$");

          _this4.$store.dispatch('cat/edit', _this4.editCatForm).then(function (data) {
            _this4.$message({
              message: data.msg,
              type: 'success'
            });

            _this4.loading = false;

            _this4.$router.push({
              path: '/cats/list'
            });
          }).catch(function () {
            _this4.loading = false;
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    onCancel: function onCancel() {
      this.$message({
        message: 'cancel!',
        type: 'warning'
      });
    },
    handleUploadFileSuccess: function handleUploadFileSuccess(res, type) {
      this.editCatForm[type] = res.msg;
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isJPG = file.type === 'image/jpeg';
      var isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG 格式!');
      }

      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }

      return isJPG && isLt2M;
    },
    handleSelect: function handleSelect(item) {
      console.log(item);
    },
    handleClick: function handleClick(tab, event) {// console.log(tab, event);
    }
  }
};
exports.default = _default;